// extracted by extract-css-chunks-webpack-plugin
module.exports = {"left_box":"left_box-17qR14e5","dbox":"dbox-3d-AKCfR"};